import { render, staticRenderFns } from "./DetailsThirdParty.vue?vue&type=template&id=18f2617d&scoped=true&"
import script from "./DetailsThirdParty.vue?vue&type=script&lang=js&"
export * from "./DetailsThirdParty.vue?vue&type=script&lang=js&"
import style0 from "./DetailsThirdParty.vue?vue&type=style&index=0&id=18f2617d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f2617d",
  null
  
)

export default component.exports